import { CitiesRegionsService } from '@/modules/cities/citiesRegions-service';
// import offerListExporterFields from '@/modules/offer/offer-list-exporter-fields';
import Errors from '@/shared/error/errors';
// import Exporter from '@/shared/exporter/exporter';
import { firestoreAction,vuexfireMutations } from 'vuexfire'
import firebase from 'firebase/app';

const INITIAL_PAGE_SIZE = 20;

export default {
  namespaced: true,

  state: {
    rows: [],
    regionsListener: null,
    citiesListener: null,
    // //#region  vuexfire variables
    loadMoreLastRecord: null,
    loadFirstRecord: null,
    recordAfterLast: [],
    recordBeforeFirst: [],
    totalRecords: null,
    pagesNumber: null,
    pageCount: 0,
    mountedTable: false,
    // //#endregion
    regionsOfCity: [],
    regionsRows:[],
    count: 0,
    loading: false,
    backgroundLoading: false,
    filter: {},
    pagination: {},
    sorter: {},

    table: null,
  },

  getters: {
    backgroundLoading: (state) => state.backgroundLoading,
    loading: (state) => state.loading,

    exportLoading: (state) => state.exportLoading,

    rows: (state) => state.rows || [],
    citiesListener: (state) => state.citiesListener,
    regionsListener: (state) => state.regionsListener,
    regionsRows: (state) => state.regionsRows || [],
    regionsOfCity: (state) => state.regionsOfCity || [],
    // //#region vuexfire getters

    mountedTable: (state) => state.mountedTable,
    loadMoreLastRecord: (state) => {
      return state.loadMoreLastRecord
    },
    loadFirstRecord: (state) =>{
      return state.loadFirstRecord
    },
    recordAfterLast: (state) => state.recordAfterLast,
    recordBeforeFirst: (state) => state.recordBeforeFirst,
    totalRecords: (state) => state.totalRecords,
    pagesNumber: (state) => state.pagesNumber,
    pageCount: (state) => state.pageCount,

    // //#endregion


    count: (state) => state.count,

    hasRows: (state, getters) => getters.count > 0,

    orderBy: (state) => {
      const sorter = state.sorter;

      if (!sorter) {
        return null;
      }

      if (!sorter.prop) {
        return null;
      }

      let direction =
        sorter.order === 'descending' ? 'DESC' : 'ASC';

      return `${sorter.prop}_${direction}`;
    },

    filter: (state) => state.filter,

    limit: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return INITIAL_PAGE_SIZE;
      }

      return pagination.pageSize;
    },

    offset: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return 0;
      }

      const currentPage = pagination.currentPage || 1;

      return (currentPage - 1) * pagination.pageSize;
    },

    pagination: (state, getters) => {
      return {
        ...state.pagination,
        total: getters.count,
        showSizeChanger: true,
      };
    },

    selectedRows: (state) => {
      return state.table ? state.table.selection : [];
    },
  },

  mutations: {
    RESETED(state) {
      state.rows = [];
      state.count = 0;
      state.loading = false;
      state.filter = {};
      state.pagination = {};
      state.sorter = {};
      if (state.table) {
        state.table.clearSelection();
      }
    },

    UNSELECT_ALL(state) {
      if (state.table) {
        state.table.clearSelection();
      }
    },

    TABLE_MOUNTED(state, payload) {
      state.table = payload;
    },

    PAGINATION_CHANGED(state, payload) {
      state.pagination = payload || {};
    },

    PAGINATION_CURRENT_PAGE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: payload || 1,
        pageSize:
          previousPagination.pageSize || INITIAL_PAGE_SIZE,
      };
    },

    PAGINATION_PAGE_SIZE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: previousPagination.currentPage || 1,
        pageSize: payload || INITIAL_PAGE_SIZE,
      };
    },

    SORTER_CHANGED(state, payload) {
      state.sorter = payload || {};
    },

    FETCH_STARTED_IN_BACKGROUND(state, payload) {
      state.backgroundLoading = true;
      if (state.table) {
        state.table.clearSelection();
      }

      state.filter =
        payload && payload.filter ? payload.filter : {};
      state.pagination =
        payload && payload.keepPagination
          ? state.pagination
          : {};
    },

    FETCH_STARTED(state,payload) {
      state.loading = true;

      if (state.table) {
        state.table.clearSelection();
      }

      state.filter =
        payload && payload.filter ? payload.filter : {};
      state.pagination =
        payload && payload.keepPagination
          ? state.pagination
          : {};
    },

    FETCH_SUCCESS(state,payload) {
      state.loading = false;
      state.backgroundLoading = false;
      state.rows = payload.rows;
      // console.log('store rows',state.rows)
      state.count = payload.count;
      state.regionsRows = payload.regions
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.backgroundLoading = false;
      state.rows = [];
      state.count = 0;
    },

    EXPORT_STARTED(state) {
      state.exportLoading = true;
    },

    EXPORT_SUCCESS(state) {
      state.exportLoading = false;
    },

    EXPORT_ERROR(state) {
      state.exportLoading = false;
    },
    SET_REGIONS_LISTENER(state,payload){
      state.regionsListener = payload
    }, 
    SET_CITIES_LISTENER(state,payload){
      state.citiesListener = payload
    }, 
     // //#region VuexfireMutations
     ...vuexfireMutations,
     SET_MOUNTEDTABLE(state,payload){
       state.mountedTable = payload
     },
     SET_LOADMORE_LAST(state) {
       // state.rows.pop()
       // console.log('state.rows',state.rows.pop());
       state.loadMoreLastRecord = state.rows[state.rows.length - 1]._doc
       state.recordAfterLast = state.rows[state.rows.length - 1]
     },
     SET_LOADFIRSTRECORD(state){
       state.loadFirstRecord = state.rows[0]._doc
     },
     RESET_CURSOR(state){
       state.loadMoreLastRecord = null
       state.loadFirstRecord = null
     },
     REMOVELASTELEMENT(state){
       state.rows.pop()
     },
     SET_TOTAL_RECORDS(state,payload){
       state.totalRecords = payload
       state.pagesNumber = Math.ceil(state.totalRecords / 10)
     },
     SET_PAGE_COUNT(state,payload){
       state.pageCount = payload
     }
     // //#endregion
  },

  actions: {
    doUnselectAll({ commit }) {
      commit('UNSELECT_ALL');
    },

    doMountTable({ commit }, table) {
      commit('TABLE_MOUNTED', table);
    },

    async doReset({ commit, dispatch }) {
      commit('RESETED');
      return dispatch('doFetch');
    },

    doChangePagination(
      { commit, getters, dispatch },
      pagination,
    ) {
      commit('PAGINATION_CHANGED', pagination);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangePaginationPageSize(
      { commit, getters, dispatch },
      pageSize,
    ) {
      commit('PAGINATION_PAGE_SIZE_CHANGED', pageSize);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangePaginationCurrentPage(
      { commit, getters, dispatch },
      currentPage,
    ) {
      commit(
        'PAGINATION_CURRENT_PAGE_CHANGED',
        currentPage,
      );
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangeSort({ commit, getters, dispatch }, sorter) {
      commit('SORTER_CHANGED', sorter);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },
    // //#region vuexfire
    setMountedTable({commit},value){
      commit('SET_MOUNTEDTABLE',value)
    },
    // doFetch:  firestoreAction(async ({bindFirestoreRef,getters,commit,dispatch},payload) => {
    //   commit('SET_PAGE_COUNT',getters.pageCount + 1)
    //   commit('FETCH_STARTED')
    //   console.log('payload',payload);
    //   const customSerializer = (doc) => {
    //     const data = doc.data()
    //     Object.defineProperty(data, '_doc', { value: doc })
    //     return data
    //   }
    //   console.log('loadMoreLastJob',getters.loadMoreLastRecord);
    //   const db = firebase.firestore()
    //   var cityCollection = getters.loadMoreLastRecord ? 
    //   db.collection('city')
    //   .startAfter(getters.loadMoreLastRecord) :
    //   db.collection('city')

    //   await bindFirestoreRef(
    //     'rows',
    //     cityCollection,
    //     { 
    //       serialize: customSerializer,
    //       maxRefDepth: 2
    //     },
    //   );
    //   // console.log('context.getters.rows',getters.rows[1].id);
    //   // var regionCollection = db.collection('city')
    //   //   .doc(getters.rows[1].id).collection('regions')
    //   //   await bindFirestoreRef(
    //   //         `regionsOfCity`,
    //   //         regionCollection,
    //   //         // { serialize: customSerializer }
    //   //       )

    //   // var regionCollection = null
    //   getters.rows.forEach(async(city) => {
    //     console.log('city',city.id);
    //     setTimeout(() => {
    //       dispatch('doFetchRegions',city.id)
    //     }, 2000);
        
    //     // regionCollection = db.collection('city')
    //     // .doc(city.id)
    //     // .collection('regions')
    //     // await bindFirestoreRef(
    //     //   `regionsOfCity`,
    //     //   regionCollection,
    //     //   { wait: true }
    //     // )
    //     // console.log('regionsOfCity',getters.regionsOfCity);
    //     // 
    //   })
    //   commit('FETCH_SUCCESS')    
    // }),
    // doFetchRegions: firestoreAction( ({ bindFirestoreRef}, payload) => {
    //   console.log('hena');
    //   const db = firebase.firestore()
    //   var regionCollection = 
    //   db.collection('city').doc(payload).collection('regions')
    //   return  bindFirestoreRef(
    //         `regionsOfCity`,
    //         regionCollection,
    //       )
    //   // console.log('getters.regionsOfCity',getters.regionsOfCity);
    //   // regionCollection = 
    //   // db.collection('city').doc(getters.rows[3].id).collection('regions')
    //   // await bindFirestoreRef(
    //   //       `regionsOfCity`,
    //   //       regionCollection,
    //   //     )
    //   // console.log('getters.regionsOfCity',getters.regionsOfCity);
    // }),
    setLoadMoreLast({commit}){
      commit('SET_LOADMORE_LAST')
    },
    resetCursor({commit}){
      commit('RESET_CURSOR')
    },
    setLoadFirstRecord({commit}){
      commit('SET_LOADFIRSTRECORD')
    },
    removeLastElement({commit}){
      commit('REMOVELASTELEMENT')
    },
    getPreviousRecordsBatch: firestoreAction(async ({bindFirestoreRef,getters,commit},payload) => {
      // getters.pageCount = getters.pageCount - 1
      commit('SET_PAGE_COUNT',getters.pageCount - 1)
      const customSerializer = (doc) => {
        const data = doc.data()
        // console.log('go to Previous ====>',data.name);
        Object.defineProperty(data, '_doc', { value: doc })
        return data
      }
      const db = firebase.firestore()
      var cityCollection =  db.collection('city')
        .orderBy('name','asc')
        .endBefore(getters.loadFirstRecord)
        .limitToLast(payload.limit || 10)
        await bindFirestoreRef(
          'rows',
          cityCollection
          ,
          { serialize: customSerializer }
        )
    }),
    setDisableNext: firestoreAction(async ({getters, bindFirestoreRef}) => {
      const db = firebase.firestore()
      var cityCollection = db.collection('city')
          .orderBy('name', 'asc')
          .limit(1)
          .startAfter(getters.loadMoreLastRecord) 
      await bindFirestoreRef(
          'recordAfterLast',
          cityCollection
          // ,
          // { serialize: customSerializer }
        )

    }),
    setDisablePrevious: firestoreAction(async ({getters, bindFirestoreRef}) => {
      // console.log('setDisablePrevious',getters.loadFirstRecord);
      const db = firebase.firestore()
      var cityCollection = db.collection('city')
          .orderBy('name','asc')
          .endBefore(getters.loadFirstRecord)
          .limitToLast(1) 
      // console.log('loadMoreLastJob',getters.loadFirstRecord);
      await bindFirestoreRef(
          'recordBeforeFirst',
          cityCollection
          // ,
          // { serialize: customSerializer }
        )
      // console.log('recordBeforeFirst',getters.recordBeforeFirst);

    }),
// //#endregion

    async doFetch(
      { commit, getters },
      { filter, keepPagination } = {},
    ) {
      try {
        commit('FETCH_STARTED', { filter, keepPagination });

        const response = await CitiesRegionsService.list(
          filter,
          getters.orderBy,
          // getters.limit,
          // getters.offset,
        );
        let regions = []
        response.rows.forEach((city) => {
          city.regions.forEach((region) => {
            regions.push({
              city:city.name,
              region})
          })
        })
        commit('FETCH_SUCCESS', {
          rows: response.rows,
          count: response.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },
    
    async doFetchInBackground(
      { commit, getters },
      { filter, keepPagination } = {},
    ) {
      try {
        commit('FETCH_STARTED_IN_BACKGROUND', { filter, keepPagination });

        const response = await CitiesRegionsService.list(
          filter,
          getters.orderBy,
          // getters.limit,
          // getters.offset,
        );
        let regions = []
        response.rows.forEach((city) => {
          city.regions.forEach((region) => {
            regions.push({
              city:city.name,
              region})
          })
        })
        commit('FETCH_SUCCESS', {
          rows: response.rows,
          regions,
          count: response.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    setRegionsListener({ commit }, payload){
      commit('SET_REGIONS_LISTENER', payload)
    },
    setCitiesListener({ commit }, payload){
      commit('SET_CITIES_LISTENER', payload)
    }

  },
};
